import { render, staticRenderFns } from "./AdminTypeNotice.vue?vue&type=template&id=ae68a73a&"
import script from "./AdminTypeNotice.vue?vue&type=script&lang=js&"
export * from "./AdminTypeNotice.vue?vue&type=script&lang=js&"
import style0 from "./AdminTypeNotice.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AdminTypeNotice.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports